// extracted by mini-css-extract-plugin
export default {"notFoundPageContainer":"Not-Found_notFoundPageContainer__yCX3V","wrapper":"Not-Found_wrapper__+GXRZ"};